import * as React from 'react';
import { ModalProps } from 'antd/es/modal';
import { useEffect, useState } from 'react';
import t from 'utils/translations';
import { ConfirmationModal } from 'components/pages/grouplistpage/actionmenu/DeleteGroupModal';

import { Form, message } from 'antd';
import { validateNameRegex } from 'utils/validation';
import { apiUpdateCategory } from 'api/categories';
import AutoSelectingInput from 'components/pages/grouplistpage/actionmenu/AutoSelectingInput';
import { apiUpdateGroup } from 'api/groups';

interface Props extends ModalProps {
    afterSuccess: () => void;
    closeModal: () => void;
    id: string;
    initialName: string;
    isCategory: boolean;
}

function RenameGroupOrCategoryModal({
    afterSuccess,
    closeModal,
    id,
    initialName,
    isCategory,
    visible
}: Props) {
    const [newName, setNewName] = useState(initialName);

    const [emptyNameError, setEmptyNameError] = useState(false);
    const [invalidNameError, setInvalidNameError] = useState(false);

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setEmptyNameError(false);
        setInvalidNameError(false);
        setNewName(initialName);
    }, [visible]);

    function handleCancel() {
        closeModal();
    }

    function handleOk() {
        const apiUpdateFunction = isCategory
            ? apiUpdateCategory
            : apiUpdateGroup;

        if (validateForm()) {
            setIsLoading(true);
            apiUpdateFunction(id, newName)
                .then(res => {
                    if (res.status === 200) {
                        message.success(t('GROUP_RENAME_SUCCESS'));
                        afterSuccess();
                    }
                })
                .catch(() => message.error(t('GROUP_RENAME_FAIL')))
                .finally(() => setIsLoading(false));
        }
    }

    function handleNameChange(e: any) {
        const name = e.target.value;

        if (validateNameRegex(name)) {
            setInvalidNameError(false);
        } else {
            setInvalidNameError(true);
        }
        setEmptyNameError(false);
        setNewName(name);
    }

    function selectNameHelpMessage() {
        if (emptyNameError) {
            return t('EMPTY_NAME_ERROR');
        } else if (invalidNameError) {
            return t('INVALID_NAME_ERROR');
        }
        return undefined;
    }

    function validateForm() {
        if (newName.length === 0) {
            setEmptyNameError(true);
            return false;
        } else if (!validateNameRegex(newName)) {
            setInvalidNameError(true);
            return false;
        }
        return true;
    }

    return (
        <ConfirmationModal
            cancelText={t('CANCEL_MODAL')}
            confirmLoading={isLoading}
            destroyOnClose={true}
            onCancel={() => {
                handleCancel();
            }}
            onOk={() => handleOk()}
            okText={t('RENAME_CONFIRMATION')}
            title={t('RENAME_GROUP_MODAL_TITLE')}
            visible={visible}
        >
            <Form>
                <Form.Item
                    colon={false}
                    help={selectNameHelpMessage()}
                    validateStatus={
                        emptyNameError || invalidNameError ? 'error' : undefined
                    }
                    label={t('RENAME_GROUP_LABEL')}
                >
                    <AutoSelectingInput
                        defaultValue={initialName}
                        maxLength={50}
                        onChange={e => handleNameChange(e)}
                        value={newName}
                    />
                </Form.Item>
            </Form>
        </ConfirmationModal>
    );
}

export default RenameGroupOrCategoryModal;
